/* tslint:disable */
/* eslint-disable */
/**
 * external-information-requests
 * Medicaid Pending document requests to family members, with the staff workspace and the family portal
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ChecklistTemplate } from './ChecklistTemplate';
import {
    ChecklistTemplateFromJSON,
    ChecklistTemplateFromJSONTyped,
    ChecklistTemplateToJSON,
    ChecklistTemplateToJSONTyped,
} from './ChecklistTemplate';

/**
 * 
 * @export
 * @interface ChecklistTemplateResponse
 */
export interface ChecklistTemplateResponse {
    /**
     * 
     */
    data: ChecklistTemplate;
}

/**
 * Check if a given object implements the ChecklistTemplateResponse interface.
 */
export function instanceOfChecklistTemplateResponse(value: object): value is ChecklistTemplateResponse {
    if (!('data' in value) || value['data'] === undefined) return false;
    return true;
}

export function ChecklistTemplateResponseFromJSON(json: any): ChecklistTemplateResponse {
    return ChecklistTemplateResponseFromJSONTyped(json, false);
}

export function ChecklistTemplateResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ChecklistTemplateResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': ChecklistTemplateFromJSON(json['data']),
    };
}

export function ChecklistTemplateResponseToJSON(json: any): ChecklistTemplateResponse {
    return ChecklistTemplateResponseToJSONTyped(json, false);
}

export function ChecklistTemplateResponseToJSONTyped(value?: ChecklistTemplateResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': ChecklistTemplateToJSON(value['data']),
    };
}

